<template>
	<div class="modal fade" id="admin-modal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 align="center" class="modal-title" id="myModalLabel">Administración de Videos</h4>
              </div>
              <div class="modal-body">
                <div id="vueApp">
                  <form style="padding-left: 10%; padding-right: 10%;">
                    <div class="form-group">
                      <label for="correo">Usuario</label>
                      <input type="text" class="form-control" placeholder="Usuario"
                      v-model="usuario">
                    </div> 
                    <div class="form-group">
                      <label for="clave">Contraseña</label>
                      <input type="password" class="form-control" placeholder="Contraseña" 
                      v-model="contrasena">
                    </div>
                  </form>
                </div>
              </div>
              <div style="text-align: center;" class="modal-footer">
                <button type="submit" class="btn btn-primary"
                        v-on:click="iniciarSesion">
                        Iniciar Sesión
                </button>
              </div>
            </div>
          </div>
        </div>
</template>
<script>
	export default{
		data(){
			return{
				usuario:'',
        contrasena:''
			}
		},
    methods:{
      iniciarSesion : function(){
        //console.log(usuario);
        if(this.usuario === 'admin' && this.contrasena === 'adn2468'){
            this.$emit('key',true);
            $('#admin-modal').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        }
        else{
          this.$emit('key',false);
          alert("Credenciales invalidas");
        }
      }
    }
	}
</script>


// WEBPACK FOOTER //
// src/LoginComponent.vue